// extracted by mini-css-extract-plugin
module.exports = {"root":"TabBar_root__jrL6_","large":"TabBar_large__zrSxZ","small":"TabBar_small__ZkByE","tab":"TabBar_tab__77nrH","active":"TabBar_active__ICdFo","tabName":"TabBar_tabName__tEkyq"};